import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../../../types/titles';
import CryptoWithdrawConfirmationLayout from '../../../../components/withdraw/crypto/confirmation';

const CryptoWithdrawConfirmation = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.WITHDRAW.CRYPTO.CONFIRMATION}</title>
			</Helmet>
			<CryptoWithdrawConfirmationLayout />
		</>
	);
};

export default CryptoWithdrawConfirmation;
